export default function (Alpine) {
    Alpine.store('cityUI', {
        open: false,

        show() {
            this.open = true;
        },

        hide() {
            this.open = false;
        },
    });
}
